import api from './api';

// Interface para Cliente (del modelo de ventas)
export interface Cliente {
  id: number;
  nombre: string;
  apellido?: string;
  dni?: string;
  ruc?: string;
  telefono?: string;
  email?: string;
  direccion?: string;
  activo: boolean;
  fecha_registro: string;
}

// Interface para DireccionEntrega (del modelo de pedidos)
export interface DireccionEntrega {
  id: number;
  cliente: number;
  nombre: string;
  direccion_linea1: string;
  direccion_linea2?: string;
  ciudad: string;
  distrito: string;
  codigo_postal?: string;
  telefono_contacto?: string;
  referencia?: string;
  es_predeterminada: boolean;
  activa: boolean;
  fecha_creacion: string;
  fecha_actualizacion: string;
}

// Interface para Direccion (del modelo auth_app) - Esta es la que usa el backend para crear pedidos
export interface DireccionAuth {
  id: number;
  user: number;
  apodo: string;
  calle: string;
  numero: string;
  referencia?: string;
  ciudad: string;
  comuna: string;
  codigo_postal?: string;
  telefono?: string;
  es_principal: boolean;
  activa: boolean;
  fecha_creacion: string;
  fecha_actualizacion: string;
}

// Obtener todos los clientes
export const getClientes = async (): Promise<Cliente[]> => {
  const response = await api.get('/ventas/clientes/');
  const data = response.data;
  return Array.isArray(data) ? data : (data.results || []);
};

// Obtener un cliente por ID
export const getClienteById = async (id: number): Promise<Cliente> => {
  const response = await api.get(`/ventas/clientes/${id}/`);
  return response.data;
};

// Crear un nuevo cliente
export const createCliente = async (data: Partial<Cliente>): Promise<Cliente> => {
  const response = await api.post<Cliente>('/ventas/clientes/', data);
  return response.data;
};

// Actualizar un cliente
export const updateCliente = async (id: number, data: Partial<Cliente>): Promise<Cliente> => {
  const response = await api.patch<Cliente>(`/ventas/clientes/${id}/`, data);
  return response.data;
};

// Obtener direcciones de un cliente (del modelo auth_app) - Estas son las que usa el backend para crear pedidos
export const getDireccionesAuthCliente = async (clienteEmail: string): Promise<DireccionAuth[]> => {
  try {
    // Obtener direcciones directamente del endpoint de auth (no auth-app)
    const response = await api.get(`/auth/direcciones/por-email/`, {
      params: { email: clienteEmail }
    });
    const data = response.data;
    console.log('📍 Respuesta de direcciones auth:', data);
    return Array.isArray(data) ? data : (data.results || []);
  } catch (error) {
    console.error('Error al obtener direcciones de auth:', error);
    // Si el endpoint no existe, intentar obtener todas las direcciones del usuario
    try {
      const response = await api.get(`/auth/direcciones/`);
      const data = response.data;
      return Array.isArray(data) ? data : (data.results || []);
    } catch (err) {
      console.error('Error al obtener direcciones (fallback):', err);
      return [];
    }
  }
};

// Obtener direcciones de un cliente (del modelo pedidos - DEPRECATED, usar getDireccionesAuthCliente)
export const getDireccionesCliente = async (clienteId: number): Promise<DireccionEntrega[]> => {
  const response = await api.get(`/pedidos/direcciones-entrega/`, {
    params: { cliente: clienteId }
  });
  const data = response.data;
  return Array.isArray(data) ? data : (data.results || []);
};

// Crear una nueva dirección de entrega para un cliente
export const createDireccionEntrega = async (data: Partial<DireccionEntrega>): Promise<DireccionEntrega> => {
  const response = await api.post<DireccionEntrega>('/pedidos/direcciones-entrega/', data);
  return response.data;
};

// Actualizar una dirección de entrega
export const updateDireccionEntrega = async (id: number, data: Partial<DireccionEntrega>): Promise<DireccionEntrega> => {
  const response = await api.patch<DireccionEntrega>(`/pedidos/direcciones-entrega/${id}/`, data);
  return response.data;
};

// Eliminar una dirección de entrega
export const deleteDireccionEntrega = async (id: number): Promise<void> => {
  await api.delete(`/pedidos/direcciones-entrega/${id}/`);
};
